import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import orderBy from 'lodash/orderBy';
import StationNode from './StationNode';
import nodeStyles from '../constants/nodeStyles';

export default function StationNodes(props) {
    const nodesRef = useRef();
    const [lineLength, setLineLength] = useState('0px');

    function createConnectingLineClassName(modifier) {
        return `station-nodes__connecting-line station-nodes__connecting-line--arrival station-node__connecting-line--${modifier}`;
    }

    // eslint-disable-next-line complexity
    function buildConnectingLineClassName(node) {
        switch (node.style) {
            case nodeStyles.success:
            case nodeStyles.critical:
            case nodeStyles.pickedUp:
                return createConnectingLineClassName('completed');
            case nodeStyles.future:
                return createConnectingLineClassName('future');
            case nodeStyles.void:
                return createConnectingLineClassName('void');
            default:
                return 'station-nodes__connecting-line station-nodes__connecting-line--arrival';
        }
    }

    function buildDotsClassName(numberOfNodes) {
        return numberOfNodes === 1
            ? 'station-nodes__dots station-nodes__dots--single'
            : 'station-nodes__dots';
    }

    useEffect(() => {
        function calculateLineLength() {
            if (props.nodes.length === 1) {
                return `${nodesRef.current.offsetWidth}px`;
            }

            return `calc((${nodesRef.current.offsetWidth}px - 12rem) / ${
                props.nodes.length - 1
            })`;
        }

        setLineLength(calculateLineLength());

        let resizeObserver;
        if (nodesRef.current) {
            resizeObserver = new ResizeObserver(() =>
                setLineLength(calculateLineLength())
            );
            resizeObserver.observe(nodesRef.current);
        }

        return () => resizeObserver.disconnect();
    }, [props.nodes]);

    return (
        <div className="station-nodes" ref={nodesRef}>
            <div
                className={buildConnectingLineClassName(props.connectingNode)}
                style={{ width: '12.5rem', right: `calc(100% - 6rem)` }}
            />
            <div className={buildDotsClassName(props.nodes.length)}>
                {orderBy(props.nodes, 'sortOrder').map((node) => (
                    <StationNode
                        key={node.sortOrder}
                        node={node}
                        lineLength={lineLength}
                    />
                ))}
            </div>
        </div>
    );
}

StationNodes.propTypes = {
    nodes: PropTypes.instanceOf(Array),
    connectingNode: PropTypes.instanceOf(Object),
};
